import Vue from "vue";
import SimpleVueValidation from "simple-vue-validator";
import util from "@/mixins/util";

const Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            title: '',
            mainImage: [],
            link: '',
            minPoint: '',
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.')
        },
        mainImage: function (value) {
            return Validator.value(value)
        },
        link: function (value) {
            return Validator.value(value)
                .required('이동링크를 입력해주세요.')
        },
        minPoint: function (value) {
            return Validator.value(value)
                .required('최소 전환가능 포인트를 입력해주세요.')
                .integer('숫자만 입력 가능합니다.')
        },
    },
    methods: {},
    computed: {}
}

